<ng-container
  *ngIf="{
    enabled: (displayEnabled$ | async),
    opened: (opened$ | async),
  } as observables"
>
  <div
    #contentElement
    class="content"
    [ngClass]="{ 'with-gradient': !observables.opened && observables.enabled }"
    [ngStyle]="{ height: observables.enabled && (heightInPx$ | async) }"
  >
    <ng-content></ng-content>
  </div>
  <div class="show-all-button-container" *ngIf="observables.enabled">
    <button
      class="show-all-button"
      (click)="onToggle()"
      [ngClass]="{ opened: observables.opened }"
      [attr.data-analytics]="dataAnalytics"
    >
      {{ observables.opened ? collapseText || 'Скрыть' : showAllText || 'Показать полностью' }}
    </button>
  </div>
</ng-container>
